// Placeholder page - will redirect to space list
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function KmsPage() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/kms/spaces');
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen">
      <p>Redirecting to spaces...</p>
    </div>
  );
}
